import { Bot, CreditCard, Repeat } from 'lucide-react' // Zap removed: DEPRECATED Features tab
import { useState } from 'react'
import {
  SubtleTabs,
  SubtleTabsContent,
  SubtleTabsList,
  SubtleTabsTrigger,
} from '@/shared/components/common/tabs/SubtleTabs'
import { AgentsUsageTab } from './AgentsUsageTab'
// import { FeaturesUsageTab } from './FeaturesUsageTab' // DEPRECATED: Features UI hidden
import { OneTimeCostsTab } from './OneTimeCostsTab'
import { RecurringChargesTab } from './RecurringChargesTab'

interface PlanConfigurationTabsProps {
  planId: string
}

export function PlanConfigurationTabs({ planId }: PlanConfigurationTabsProps) {
  const [activeTab, setActiveTab] = useState('fixed-costs')

  return (
    <SubtleTabs value={activeTab} onValueChange={setActiveTab}>
      <SubtleTabsList>
        <SubtleTabsTrigger
          value='fixed-costs'
          className='flex items-center gap-2'
        >
          <CreditCard className='w-4 h-4' />
          One-time Costs
        </SubtleTabsTrigger>
        <SubtleTabsTrigger
          value='recurring-charges'
          className='flex items-center gap-2'
        >
          <Repeat className='w-4 h-4' />
          Recurring Charges
        </SubtleTabsTrigger>
        <SubtleTabsTrigger
          value='agents-usage'
          className='flex items-center gap-2'
        >
          <Bot className='w-4 h-4' />
          Agents (Usage)
        </SubtleTabsTrigger>
        {/* DEPRECATED: Features (Usage) tab hidden (see DEPRECATED.md) */}
        {/* <SubtleTabsTrigger
          value='features-usage'
          className='flex items-center gap-2'
        >
          <Zap className='w-4 h-4' />
          Features (Usage)
        </SubtleTabsTrigger> */}
      </SubtleTabsList>

      {/* One-Time Costs Tab */}
      <SubtleTabsContent value='fixed-costs'>
        <OneTimeCostsTab planId={planId} />
      </SubtleTabsContent>

      {/* Recurring Charges Tab */}
      <SubtleTabsContent value='recurring-charges'>
        <RecurringChargesTab planId={planId} />
      </SubtleTabsContent>

      {/* Agents Usage Tab */}
      <SubtleTabsContent value='agents-usage'>
        <AgentsUsageTab planId={planId} />
      </SubtleTabsContent>

      {/* DEPRECATED: Features Usage Tab hidden (see DEPRECATED.md) */}
      {/* <SubtleTabsContent value='features-usage'>
        <FeaturesUsageTab planId={planId} />
      </SubtleTabsContent> */}
    </SubtleTabs>
  )
}
